'use strict';

var _ = require('lodash');
var PaxGridSelectionModelFactory = function PaxGridSelectionModelFactory() {
  var PaxGridSelectionModel = function PaxGridSelectionModel() {
    this._latestSelectedNumber = null;
    this._currentSelection = [];
    this.selectionType = null;
    this.selectionValues = [];
    this.rows = [];
    this.columns = [];
  };
  PaxGridSelectionModel.ROW_SELECTION = 'row';
  PaxGridSelectionModel.COLUMN_SELECTION = 'column';
  PaxGridSelectionModel.prototype._getValue = function (n) {
    return this.isRowSelection() ? this.rows[n][0].value : this.columns[n].label;
  };
  PaxGridSelectionModel.prototype._fulfillSelectionValues = function () {
    if (this.selectionType === null) {
      this.selectionValues = [];
    }
    this.selectionValues = [];
    for (var i = 0; i < this._currentSelection.length; i++) {
      var n = this._currentSelection[i];
      var value = this._getValue(n);
      this.selectionValues.push(value);
    }
  };
  PaxGridSelectionModel.prototype._inTheSameRange = function (_latestSelectedNumber, number) {
    if (_latestSelectedNumber === number) {
      return true;
    }
    var min = Math.min(_latestSelectedNumber, number);
    var max = Math.max(_latestSelectedNumber, number);
    for (var i = min; i <= max; i++) {
      if (this._currentSelection.indexOf(i) === -1) {
        return false;
      }
    }
    return true;
  };
  PaxGridSelectionModel.prototype._getLeftBorder = function (number) {
    while (this._currentSelection.indexOf(number - 1) !== -1) {
      number--;
    }
    return number;
  };
  PaxGridSelectionModel.prototype._getRightBorder = function (number) {
    while (this._currentSelection.indexOf(number + 1) !== -1) {
      number++;
    }
    return number;
  };
  PaxGridSelectionModel.prototype._findNearestPoint = function (number) {
    var nearestPoint = this._currentSelection[0];
    var distance = Math.abs(nearestPoint - number);
    for (var i = 1; i < this._currentSelection.length; i++) {
      var current = this._currentSelection[i];
      var currentDistance = Math.abs(current - number);
      if (currentDistance <= distance) {
        nearestPoint = current;
        distance = currentDistance;
      }
    }
    return nearestPoint;
  };
  PaxGridSelectionModel.prototype._isSinglePointSelection = function (number) {
    return this._currentSelection.indexOf(number + 1) === -1 && this._currentSelection.indexOf(number - 1) === -1;
  };
  PaxGridSelectionModel.prototype.resetSelection = function () {
    this._currentSelection = [];
    this._latestSelectedNumber = null;
    this.selectionValues = [];
    this.selectionType = null;
  };
  PaxGridSelectionModel.prototype.setSelectionValues = function (values) {
    this.selectionValues = _.cloneDeep(values);
    this._currentSelection = [];
    var data = this.isRowSelection() ? this.rows : this.columns;
    for (var i = 0; i < values.length; i++) {
      var value = values[i];
      for (var n = 0; n < data.length; n++) {
        if (value === this._getValue(n)) {
          this._currentSelection.push(n);
          break;
        }
      }
    }
  };
  PaxGridSelectionModel.prototype.setColumns = function (columns) {
    this.columns = columns;
  };
  PaxGridSelectionModel.prototype.setRows = function (rows) {
    this.rows = rows;
  };
  PaxGridSelectionModel.prototype.selectionByRow = function () {
    if (this.selectionType !== PaxGridSelectionModel.ROW_SELECTION) {
      this.resetSelection();
    }
    this.selectionType = PaxGridSelectionModel.ROW_SELECTION;
  };
  PaxGridSelectionModel.prototype.selectionByColumn = function () {
    if (this.selectionType !== PaxGridSelectionModel.COLUMN_SELECTION) {
      this.resetSelection();
    }
    this.selectionType = PaxGridSelectionModel.COLUMN_SELECTION;
  };
  PaxGridSelectionModel.prototype.isRowSelection = function () {
    return this.selectionType === PaxGridSelectionModel.ROW_SELECTION;
  };
  PaxGridSelectionModel.prototype.setSelection = function (number, ctrlKey, shiftKey) {
    var min, max;
    if (!ctrlKey && !shiftKey) {
      this._currentSelection = [number];
      this._latestSelectedNumber = number;
    } else if (ctrlKey && !shiftKey) {
      var index = this._currentSelection.indexOf(number);
      if (index === -1) {
        this._currentSelection.push(number);
        this._latestSelectedNumber = number;
      } else if (!this._isSinglePointSelection(number)) {
        this._currentSelection.splice(index, 1);
        this._latestSelectedNumber = this._findNearestPoint(number);
      }
    } else {
      if (this._latestSelectedNumber === null) {
        this._currentSelection.push(number);
      } else if (!this._inTheSameRange(this._latestSelectedNumber, number)) {
        min = Math.min(this._getLeftBorder(this._latestSelectedNumber), number);
        max = Math.max(this._getRightBorder(this._latestSelectedNumber), number);
        this._currentSelection = !ctrlKey ? [] : this._currentSelection;
        while (min <= max) {
          if (this._currentSelection.indexOf(min) !== -1) {
            min++;
          } else {
            this._currentSelection.push(min++);
          }
        }
      }
      this._latestSelectedNumber = number;
    }
    this._fulfillSelectionValues();
  };
  return PaxGridSelectionModel;
};
PaxGridSelectionModelFactory.$inject = [];
module.exports = PaxGridSelectionModelFactory;